import React, { memo } from 'react';

const YouTubeIcon = (props) => (
    <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.5176 23.7654L10.7305 23.675C9.18054 23.6435 7.62672 23.7064 6.10716 23.38C3.79555 22.8924 3.63179 20.5015 3.46043 18.4959C3.22431 15.6764 3.31572 12.8056 3.7613 10.0096C4.01285 8.44076 5.00279 7.50462 6.53369 7.40274C11.7016 7.03304 16.9039 7.07685 22.0604 7.24933C22.605 7.26515 23.1533 7.35157 23.6903 7.44994C26.341 7.92972 26.4056 10.6392 26.5774 12.9201C26.7488 15.2245 26.6765 17.5407 26.3489 19.8294C26.0862 21.7244 25.5834 23.3135 23.4618 23.4669C20.8035 23.6675 18.2062 23.829 15.5404 23.7776C15.5405 23.7654 15.5252 23.7654 15.5176 23.7654ZM12.7032 18.9679C14.7065 17.7802 16.6715 16.6123 18.6633 15.4326C16.6563 14.2449 14.695 13.077 12.7032 11.8972V18.9679Z"
            fill="currentColor" />
    </svg>
);

export default memo(YouTubeIcon);
